import ConfirmPopup from '../../common/confirm-popup';

const DeclineSubmissionDialog = props => (
  <ConfirmPopup
    onClose={result => props.onClose(result)}
    confirmLabel="Continue"
  >
    <div className="ta-left">
      <p>
        { props.decline_custom_message ? props.decline_custom_message : 'Are you sure you want to decline this submission?' }
      </p>
    </div>
  </ConfirmPopup>
);

export default DeclineSubmissionDialog;
